import { useQuery } from '@hooks/reactQuery';

import { getPortalTasksStatuses } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_TASKS_STATUSES } from '@constants/queryKeys';

interface IUseQueryPortalTasksStatusesReturned {
	portalTasksStatuses: Array<TSelectOption>;
	isLoadingPortalTasksStatuses: boolean;
}

export const useQueryPortalTasksStatuses = (projectId?: string): IUseQueryPortalTasksStatusesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TASKS_STATUSES, projectId],
		queryFn: extractQueryParams(getPortalTasksStatuses),
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalTasksStatuses: data || [],
		isLoadingPortalTasksStatuses: isLoading || isFetching,
	};
};
